import {inject, Injectable} from '@angular/core';
import {combineLatest, map, Observable, shareReplay} from 'rxjs';
import {SessionState} from '../enum/session-state.enum';
import {AsmService} from './asm.service';
import {UserService} from './user.service';
import {toSignal} from '@angular/core/rxjs-interop';

@Injectable({providedIn: 'root'})
export class SessionService {
  private userService = inject(UserService);
  private asmService = inject(AsmService);

  public readonly sessionStates$: Observable<SessionState[]> = combineLatest([
    this.userService.getCurrentUser(),
    this.asmService.getImpersonateActiveSession(),
    this.asmService.getAsmAgent(),
  ]).pipe(
    map(([user, isImpersonateSession, asmAgent]) => {
      const matchingStates: SessionState[] = [];

      if (isImpersonateSession) {
        matchingStates.push(SessionState.IMPERSONATESESSION);
      }

      if (user) {
        matchingStates.push(SessionState.CURRENTUSER);
      }

      if (asmAgent) {
        matchingStates.push(SessionState.ASMAGENT);
      }

      if (matchingStates.length === 0) {
        matchingStates.push(SessionState.ANONYMOUS);
      }

      return matchingStates;
    }),
    shareReplay(1),
  );

  public sessionStates = toSignal(this.sessionStates$);
}
